import { useMemo } from "react";
// A simple hook to generate a random id string. In React 18, use the built in useId
const useId = () => {
  const id = useMemo(() => Math.random().toString(36).slice(2), []);

  return id;
};

export default useId;
